import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ArrowRight } from '@outdoor-voices/ui';
import cc from 'classcat';
import PropTypes from 'prop-types';
import React from 'react';
import ButtonLink from '../ButtonLink';
import LazyImg from '../LazyImg';
import css from './ProductItem.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ProductItem = function ProductItem(_ref) {
  var cta = _ref.cta,
      fabric = _ref.fabric,
      features = _ref.features,
      image = _ref.image,
      imageLeft = _ref.imageLeft,
      title = _ref.title,
      url = _ref.url;
  return /*#__PURE__*/_jsxs("li", {
    className: cc([css.root, _defineProperty({}, css.imageLeft, imageLeft)]),
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.text,
      children: [/*#__PURE__*/_jsx("a", {
        className: css.urlWrap,
        href: url,
        children: /*#__PURE__*/_jsxs("h2", {
          className: css.title,
          children: [fabric, /*#__PURE__*/_jsx("br", {}), title]
        })
      }), /*#__PURE__*/_jsx("ul", {
        className: css.features,
        children: features.map(function (feature) {
          return /*#__PURE__*/_jsx("li", {
            className: css.feature,
            children: feature
          }, feature);
        })
      }), /*#__PURE__*/_jsxs(ButtonLink, {
        className: css.cta,
        href: url,
        medium: true,
        children: [cta, /*#__PURE__*/_jsx(ArrowRight, {})]
      })]
    }), /*#__PURE__*/_jsx("a", {
      className: cc([css.urlWrap, css.imgWrap]),
      href: url,
      children: /*#__PURE__*/_jsx(LazyImg, {
        alt: title,
        className: css.image,
        src: image
      })
    })]
  });
};

ProductItem.defaultProps = {
  imageLeft: true
};
ProductItem.propTypes = {
  cta: PropTypes.string.isRequired,
  fabric: PropTypes.string.isRequired,
  features: PropTypes.arrayOf(PropTypes.string).isRequired,
  image: PropTypes.string.isRequired,
  imageLeft: PropTypes.bool,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};
export default ProductItem;